import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import clsx from 'clsx'
import { Trophy, Users, Crown, User, MoreHorizontal, Home } from 'lucide-react'
import { Badge } from '@/components/ui/Badge'

export interface MobileNavProps {
  className?: string
}

const MobileNav: React.FC<MobileNavProps> = ({ className }) => {
  const location = useLocation()

  const navItems = [
    {
      label: 'Home',
      href: '/',
      icon: Home,
      active: location.pathname === '/',
    },
    {
      label: 'Bracket',
      href: '/bracket',
      icon: Trophy,
      active: location.pathname === '/bracket',
      badge: 'Live',
    },
    {
      label: 'Leagues',
      href: '/leagues',
      icon: Users,
      active: location.pathname.startsWith('/leagues'),
    },
    {
      label: 'Leaderboard',
      href: '/leaderboard',
      icon: Crown,
      active: location.pathname === '/leaderboard',
    },
    {
      label: 'Profile',
      href: '/profile',
      icon: User,
      active: location.pathname === '/profile',
    },
    {
      label: 'More',
      href: '/more',
      icon: MoreHorizontal,
      active: ['/scout', '/store', '/settings', '/more'].some(path => location.pathname === path),
    },
  ]

  return (
    <nav className={clsx(
      'fixed bottom-0 left-0 right-0 z-50 bg-dark-600 border-t border-dark-500 safe-area-pb',
      className
    )}>
      <div className="flex">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = item.active

          return (
            <Link
              key={item.href}
              to={item.href}
              className="flex-1 flex flex-col items-center justify-center py-3 px-2 relative min-h-[64px] touch-manipulation"
            >
              {/* Active indicator */}
              {isActive && (
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-primary-500 rounded-b-lg" />
              )}

              <div className="relative">
                <Icon 
                  className={clsx(
                    'h-5 w-5 transition-colors',
                    isActive ? 'text-primary-400' : 'text-text-muted'
                  )} 
                />
                {item.badge && (
                  <Badge
                    variant={item.badge === 'Live' ? 'success' : 'primary'}
                    size="sm"
                    className="absolute -top-1 -right-2 min-w-[1rem] h-4 px-1 text-[10px]"
                  >
                    {item.badge === 'Live' ? '●' : item.badge === 'Pro' ? 'P' : item.badge}
                  </Badge>
                )}
              </div>
              
              <span className={clsx(
                'text-[10px] font-medium mt-1',
                isActive ? 'text-primary-400' : 'text-text-muted'
              )}>
                {item.label}
              </span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}

export { MobileNav }